import { render, staticRenderFns } from "./ContentGdListComponent.vue?vue&type=template&id=07156d46&scoped=true"
import script from "./ContentGdListComponent.vue?vue&type=script&lang=js"
export * from "./ContentGdListComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentGdListComponent.vue?vue&type=style&index=0&id=07156d46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07156d46",
  null
  
)

export default component.exports